import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace CustomerRepresentative {

    /**
    * 获取客户列表
    */
    export var getCustomerList = (query: any): Promise<any> => {
        return Get(`/csp/CustomerRepresentative/getCustomerList?${qs.stringify(query)}`, {});
    };


}

